import axios from 'axios';
import store from '../store';

export default function setupInterceptors() {
  axios.interceptors.response.use(
    (response) => response,
    (error) => {
      // Do something with response error
      if (axios.isCancel(error)) {
        // we ignore this
      } else if (error.response && error.response.status === 403) {
        // redirect to viewer
        window.location.href = `${store.state.baseBackendUrl}accounts/login/?next=/viewer`;
      }
      return Promise.reject(error);
    },
  );
}
